import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, map } from 'rxjs';

import { AsyncPipeBase } from '../async-pipe-base';

@Pipe({
  name: 'appKwh',
  pure: false,
  standalone: false,
})
export class KwhPipe extends AsyncPipeBase<number, [digitsInfo?: string]> implements PipeTransform {
  readonly #decimalPipe = inject(DecimalPipe);
  readonly #translateService = inject(TranslateService);

  public readonly defaultValue = '';

  public transform$(value: number, digitsInfo?: string): Observable<string> {
    return this.#translateService
      .stream('common.kwh')
      .pipe(map((kwTranslation) => `${this.#decimalPipe.transform(value, digitsInfo)} ${kwTranslation}`));
  }
}
